var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRateIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.088,
    height: 23.635,
    viewBox: "0 0 23.088 23.635",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.109,
    y1: 0.085,
    x2: 0.943,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#feb31d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb730"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8c218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb21e"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Subtraction_1",
    x: 0,
    y: 0,
    width: 23.088,
    height: 23.635,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.822,
    dy: 0.822,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.959,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#13062f",
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2106",
    x: 6.111,
    y: 6.427,
    width: 10.587,
    height: 10.222,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.548,
    dy: 0.548,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.548,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8371",
    "data-name": "Group 8371",
    transform: "translate(2.056 2.056)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 8.666,
    cy: 8.94,
    rx: 8.666,
    ry: 8.94,
    transform: "translate(0.001 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2.06, -2.06)",
    filter: "url(#Subtraction_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1-2",
    "data-name": "Subtraction 1",
    d: "M8.665,17.879A8.668,8.668,0,0,1,.659,12.361,9.147,9.147,0,0,1,2.538,2.618a8.479,8.479,0,0,1,12.255,0,9.141,9.141,0,0,1,0,12.643,8.478,8.478,0,0,1-6.128,2.618Zm0-16.389A7.338,7.338,0,0,0,1.444,8.94a7.338,7.338,0,0,0,7.221,7.45,7.338,7.338,0,0,0,7.221-7.45A7.346,7.346,0,0,0,8.665,1.49Z",
    transform: "translate(2.06 2.06)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2.06, -2.06)",
    filter: "url(#Path_2106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2106-2",
    "data-name": "Path 2106",
    d: "M2.023,6.913c1.61.127,3.761-.354,4.759-1.758a2.73,2.73,0,0,0,.475-2.068C6.883.92,3.916-.352.162.086l0,1.76c2.981-.255,5.528.032,5.965,1.518.665,2.251-2.67,2.882-3.048,2.868a1.815,1.815,0,0,0,.436-1.1A1.758,1.758,0,0,0,0,5.13C0,6.344.968,6.848,2.023,6.913Z",
    transform: "translate(7.21 7.52)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateIc);
export default __webpack_public_path__ + "static/media/rate_ic.d06f1b95f95e9caff5a1642584354198.svg";
export { ForwardRef as ReactComponent };